var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "con-exemple-prompt mb-6 scrollBug" }, [
    _c("table", { staticClass: "w-full" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.resources, function (resource, i) {
          return _c("tr", [
            _c(
              "td",
              { staticStyle: { "min-width": "350px" } },
              [
                _c("vs-input", {
                  staticClass: "w-full",
                  attrs: { size: "large", name: "title" },
                  model: {
                    value: resource.title,
                    callback: function ($$v) {
                      _vm.$set(resource, "title", $$v)
                    },
                    expression: "resource.title",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { width: "250px" } },
              [
                _c(
                  "Multiselect",
                  {
                    attrs: {
                      options: _vm.types.data.map((t) => ({ id: t, title: t })),
                      "track-by": "id",
                      label: "title",
                      multiple: false,
                      "group-select": false,
                      placeholder: "Recherche ...",
                      "select-label": "",
                      "select-group-label": "",
                      "selected-label": "",
                      "deselect-label": "",
                      "deselect-group-label": "",
                      loading: _vm.types.loading,
                    },
                    model: {
                      value: resource.type,
                      callback: function ($$v) {
                        _vm.$set(resource, "type", $$v)
                      },
                      expression: "resource.type",
                    },
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "noResult" }, slot: "noResult" },
                      [_vm._v("Aucun résultat.")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "flex items-center justify-end gap-3",
                staticStyle: { width: "88px", height: "43px" },
              },
              [
                resource.edit
                  ? _c(
                      "vs-button",
                      {
                        attrs: {
                          color: "primary",
                          type: "border",
                          radius: "",
                          disabled: !_vm.canAddNewLine(resource),
                        },
                        on: { click: _vm.addNewLine },
                      },
                      [_c("i", { staticClass: "fa fa-plus mx-1" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "vs-button",
                  {
                    staticClass: "px-5 py-3",
                    attrs: {
                      color: "primary",
                      type: "border",
                      disabled: !_vm.canRemoveLine(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.removeLine(i)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex justify-center mt-10 gap-3" },
      [
        _c(
          "vs-radio",
          {
            attrs: { "vs-name": "question_only", "vs-value": "1" },
            model: {
              value: _vm.questionOnly,
              callback: function ($$v) {
                _vm.questionOnly = $$v
              },
              expression: "questionOnly",
            },
          },
          [_vm._v("\n            Ne créer que les questions\n        ")]
        ),
        _vm._v(" "),
        _c(
          "vs-radio",
          {
            attrs: { "vs-name": "question_only", "vs-value": "0" },
            model: {
              value: _vm.questionOnly,
              callback: function ($$v) {
                _vm.questionOnly = $$v
              },
              expression: "questionOnly",
            },
          },
          [_vm._v("\n            Créer un bloc associé\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Question*")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Type*")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }